import { StoreSelector as StoreSelectorComponent } from './StoreSelector';
import { useSetStoreId } from '../../Store/hooks/useSetStoreId';
import { setStoreSelection } from '../../domains/UI/store/slice';
import { useAppDispatch, useAppSelector } from '../../reduxstore/hooks';

export const StoreSelector: React.FC = () => {
	const dispatch = useAppDispatch();
	const [, setStoreId] = useSetStoreId();

	const storeSelection = useAppSelector(
		state => state.uiReducer.storeSelection
	);

	const { isOpen, forSettingOLOStore, buttonText, source } = storeSelection;

	const onClose = () =>
		dispatch(setStoreSelection({ ...storeSelection, isOpen: false }));

	const onSelectedStore = (selectedStoreId: number) => {
		let open = false;
		if (storeSelection.source === 'FIND_STORE') open = true;
		if (storeSelection.source !== 'FAVORITE_LIST')
			setStoreId(selectedStoreId);
		dispatch(
			setStoreSelection({
				...storeSelection,
				isOpen: open,
				selectedStoreId
			})
		);
	};

	return (
		<StoreSelectorComponent
			isOpen={isOpen}
			forSettingOLOStore={forSettingOLOStore}
			showFavorite={true}
			source={source}
			buttonText={buttonText}
			buttonAction={onSelectedStore}
			toggleHandler={onClose}
		/>
	);
};
